import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const errorMessage = (e, fallback = "Something went wrong. Please try again.") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d[0]?.msg ?? fallback;
  return fallback;
};

export const joinWaitlist = (payload) => axios.post(`${API}/waitlist`, payload).then((r) => r.data);

export const fetchWaitlist = (key) =>
  axios.get(`${API}/admin/waitlist`, { headers: { "X-Admin-Key": key } }).then((r) => (Array.isArray(r.data) ? r.data : []));

export const getProfile = (vid) => axios.get(`${API}/profile/${vid}`).then((r) => r.data ?? null);
export const saveProfile = (vid, p) => axios.put(`${API}/profile/${vid}`, p).then((r) => r.data);
export const deleteProfile = (vid) => axios.delete(`${API}/profile/${vid}`);
export const getChat = (vid) => axios.get(`${API}/ai/chat/${vid}`).then((r) => (Array.isArray(r.data) ? r.data : []));
export const clearChat = (vid) => axios.delete(`${API}/ai/chat/${vid}`);

export const resendWelcome = (key, id) =>
  axios.post(`${API}/admin/waitlist/${id}/resend-welcome`, null, { headers: { "X-Admin-Key": key } }).then((r) => r.data);

export const deleteWaitlist = (key, id) =>
  axios.delete(`${API}/admin/waitlist/${id}`, { headers: { "X-Admin-Key": key } });
